<script>
</script>

<div class="orange-line"></div>

<style>
  .orange-line {
    height: 1px; /* Height of the line */
    background-color: #f7931e; /* Orange color */
    margin-top: 1rem; /* 1rem margin on the top */
    margin-bottom: 1rem; /* 1rem margin on the bottom */
    width: 100%; /* Full width */
  }
</style>